const IK = 'https://ik.imagekit.io/gnzsnmo3fr/vaidyam';

export const IMAGES = {
  // LOGO
  logo:             `${IK}/hero/logo.png`,

  // ABOUT
  doctor:           `${IK}/about/doctor.png`,
  clinic:           `${IK}/about/clinic.webp`,

  // HOME
  doctorHome:       `${IK}/home/doctor.png`,
  panchakarmaHero:  `${IK}/home/panchkarma_hero.jpg`,
  sarnaprshan:      `${IK}/home/sarnaprshan.png`,
  doshaquiz:        `${IK}/home/doshaquiz.jpg`,
  startHealing:     `${IK}/home/starthealingtoday.webp`,

  // SLIDER
  slider1:          `${IK}/slider/slider1.webp`,
  slider2:          `${IK}/slider/slider2.jpg`,
  slider3:          `${IK}/slider/slider3.jpg`,
  slider4:          `${IK}/slider/slider4.webp`,
  slider5:          `${IK}/slider/slider5.jpg`,

  // HERO PAGES
  heroBlogs:        `${IK}/hero/blogs.webp`,
  heroContact:      `${IK}/hero/contact.jpg`,
  heroConsultation: `${IK}/hero/consultation.png`,

  // BLOG THUMBNAILS
  blogDosha:        `${IK}/blogs/doshablog.webp`,
  blogPanchkarma:   `${IK}/blogs/panchkarmablog.jpg`,
  blogWeightloss:   `${IK}/blogs/weightlossblog.jpg`,
  blogSwarna:       `${IK}/blogs/sarnaprshanblog.png`,
  blogShirodhara:   `${IK}/blogs/sirodharablog.jpg`,
  blogDrMonika:     `${IK}/blogs/drmonikablog.webp`,

  // GALLERY
  gallery1:         `${IK}/gallery/gallery1.webp`,
  gallery2:         `${IK}/gallery/gallery2.webp`,
  gallery3:         `${IK}/gallery/gallery3.webp`,
  gallery4:         `${IK}/gallery/gallery4.mp4`,
  gallery5:         `${IK}/gallery/gallery5.mp4`,
  gallery6:         `${IK}/gallery/gallery6.mp4`,

  // PANCHAKARMA
  panchkarmaHero2:  `${IK}/panchkarma/panchkarma_hero.jpg`,
  panchkarmaImg:    `${IK}/panchkarma/pancharma-image.png`,
  vaman1:           `${IK}/panchkarma/vaman1.jpg`,
  vaman2:           `${IK}/panchkarma/vaman2.jpg`,
  virechan1:        `${IK}/panchkarma/virechan1.jpg`,
  virechan2:        `${IK}/panchkarma/virechan2.jpg`,
  basti1:           `${IK}/panchkarma/basti1.jpg`,
  basti2:           `${IK}/panchkarma/basti2.jpg`,
  nasyam:           `${IK}/panchkarma/nasyam.jpg`,
  nasyam1:          `${IK}/panchkarma/nasyam1.jpg`,
  raktmokshan1:     `${IK}/panchkarma/raktmokshan1.jpg`,
  raktmokshan2:     `${IK}/panchkarma/raktmokshan2.jpg`,

  // THERAPIES
  steam:            `${IK}/therapies/steam.jpg`,
  agnikarma:        `${IK}/therapies/agnikarna.png`,
  netratarpan:      `${IK}/therapies/netratarpan.png`,
  takradhara:       `${IK}/therapies/takradhara.jpg`,
  shirovasti:       `${IK}/therapies/shirovasti.jpg`,
  udwartanam:       `${IK}/therapies/udwartanam.jpg`,
  paadabhyanga:     `${IK}/therapies/paadabhyanga.jpg`,
  nadiswedan:       `${IK}/therapies/nadiswedan.jpg`,
  elakizhi:         `${IK}/therapies/elakizhi.jpg`,
  januvasti:        `${IK}/therapies/januvasti.jpg`,
  janubasti:        `${IK}/therapies/janubasti.jpg`,
  pizhichil:        `${IK}/therapies/pizhichil.jpg`,
  pichu:            `${IK}/therapies/pichu.jpg`,
  greevavasti:      `${IK}/therapies/greevavasti.jpg`,
  nasyamT:          `${IK}/therapies/nasyam.jpg`,
  shirodhara:       `${IK}/therapies/shirodhara.jpg`,
  kativasti:        `${IK}/therapies/kativasti.jpg`,
  mukhabhyang:      `${IK}/therapies/mukhabhyang.jpg`,
  taallepam:        `${IK}/therapies/taallepam.jpg`,
  dhanyamladhara:   `${IK}/therapies/dhanyamladhara.jpg`,
  leech:            `${IK}/therapies/leech.jpg`,
  taalabhyanga:     `${IK}/therapies/taalabhyanga.jpg`,
  cupping:          `${IK}/therapies/cupping.jpg`,
  mukhlepam:        `${IK}/therapies/mukhlepam.jpg`,
  kashayadhara:     `${IK}/therapies/kashayadhara.jpeg`,
  hridaybasti:      `${IK}/therapies/hridaybasti.jpg`,
  potlifacial:      `${IK}/therapies/potlifacial.avif`,
  abhyanga:         `${IK}/therapies/abhyanga.jpg`,
  navarakizhi:      `${IK}/therapies/navarakizhi.jpg`,

  // TREATMENTS
  nerves:           `${IK}/treatments/nerves.png`,
  xrayHand:         `${IK}/treatments/xray-hand.jpg`,
  skindisease:      `${IK}/treatments/skindisease.jpg`,
  psoriasis:        `${IK}/treatments/psoriosis.jpg`,
  paraplegia:       `${IK}/treatments/paraplegia.jpg`,
  vitiligo:         `${IK}/treatments/vitiligo.jpg`,
  spine:            `${IK}/treatments/spine.jpg`,
  headache:         `${IK}/treatments/headache.jpg`,
  migraine:         `${IK}/treatments/migrane.jpg`,
  obesity:          `${IK}/treatments/obsity.jpg`,
  acne:             `${IK}/treatments/acne.jpg`,
  facefacial:       `${IK}/treatments/facefacial.jpg`,
  knee:             `${IK}/treatments/knee.jpg`,
  jointpain:        `${IK}/treatments/jointpain.jpg`,
  hormones:         `${IK}/treatments/hormones.jpg`,
  eczema:           `${IK}/treatments/eczema.jpg`,
  depression:       `${IK}/treatments/depression.jpg`,
  diabetes:         `${IK}/treatments/diabetes.jpg`,
  hairfall:         `${IK}/treatments/hairfall.jpg`,
  ankylosing:       `${IK}/treatments/ankylosing-spondylitis.jpg`,
  backpain:         `${IK}/treatments/backpain.jpeg`,
  // New treatment images
  insomnia:         `${IK}/treatments/insomnia.jpg`,
  asthma:           `${IK}/treatments/asthma.webp`,
  thyroid:          `${IK}/treatments/thyroid.jpg`,
  renal:            `${IK}/treatments/renal.jpg`,
  boneMuscle:       `${IK}/treatments/bone-n-muscle.jpg`,
  frozenShoulder:   `${IK}/treatments/frozen-sholder.jpg`,
  sinusitis:        `${IK}/treatments/sinusitis.webp`,
  dandruff:         `${IK}/treatments/dandruff.jpg`,
  greyHair:         `${IK}/treatments/greyhair.jpg`,
  sciatica:         `${IK}/treatments/scatia.jpg`,
  piles:            `${IK}/treatments/piles-disease.webp`,
};
